import { Navigate, Outlet } from 'react-router';
import type { Role } from '@wrapforce/shared/constants';
import { useActiveMembership } from '@/features/session/useActiveMembership';
import { FullScreenSpinner } from './RequireAuth';

// Route-level guard mirroring nav-items.ts hiddenFor lists, so deep-linking
// past the sidebar can't reach a page the role has no server access to.
export function RequireRole({ hiddenFor }: { hiddenFor: Role[] }) {
  const { membership, isLoading } = useActiveMembership();

  if (isLoading) return <FullScreenSpinner />;
  if (membership && hiddenFor.includes(membership.role)) return <Navigate to="/" replace />;

  return <Outlet />;
}
